import { changeGameObjectImage } from "../../functions/image-functions/image-functions";
// import { loadAssetsArrayGame } from "../../functions/load-assets-functions/load-assets-functions";
import { GameElementSpecificationsInterface } from "../../interfaces/game-element-specifications-interface";
import { SceneDataInterface } from "../../interfaces/scene-data-interface";
import { EventsTouchedGameObjectsStrings } from "../../settings/game-constants-strings/game-events-strings";
import { GameSceneIdsStrings } from "../../settings/game-constants-strings/game-scene-ids-string";
import { ColorsValue } from "../../settings/game-constants-strings/text-styles-string";
import { GameFacade } from "../facade-scene/facade-scene";
import { mainSceneElementSpecifictions } from "./main-scene-specifications";

export class MainScene extends Phaser.Scene {

    private gameObjects: any;
    private facade: GameFacade;
    private pipeImage: {
        gameElementSpecification: GameElementSpecificationsInterface,
        gameObject: Phaser.GameObjects.GameObject
    };
    private mainSceneBackground: Phaser.GameObjects.Image;
    private animation: Phaser.Tweens.Tween;

    private ballArc: Phaser.GameObjects.Arc;
    private ballArcTemp: Phaser.GameObjects.Arc;
    private pipeList: Phaser.GameObjects.Sprite[] = [];
    private countStep: number = 0;
    private ballSprite: Phaser.Physics.Matter.Sprite;
    private isVisibleBall: boolean;

    private pipeAssets = [
        'pipe-red-background',
        'pipe-green-background',
        'pipe-blue-background'
    ]

    private colorValues = [
        0xE50000,
        0x188400,
        0x0B00C1
    ];

    private totalScoreText: Phaser.GameObjects.Text;
    private totalScore: number;
    
    constructor() {
        super({
            key: GameSceneIdsStrings.MAIN_SCENE_ID
        });
    }

    create() {
        this.pipeList = [];
        this.countStep = 0;
        this.totalScore = 0;
        this.facade = new GameFacade(this, mainSceneElementSpecifictions);
        this.gameObjects = this.facade.getGameObjects;
        this.isVisibleBall = false;

        this.getElements();
        this.addFunctionality();
        this.initialCounter();
    }

    update() {

        if (!this.isVisibleBall && this.ballSprite.y <= 200) {
            this.ballSprite.setVisible(true);
            this.isVisibleBall = true;
            this.ballArcTemp.setVisible(false);
        }

        this.mainSceneBackground.x -= 3;
        if (this.mainSceneBackground !== undefined) {
            if (this.mainSceneBackground.x <= 1 ) {
                this.mainSceneBackground.x = 1366;
            }
        }

        if (this.pipeList.length > 0 && this.pipeImage.gameObject !== undefined && this.countStep > 100) {
            this.pipeImage.gameElementSpecification.scale.objectPositionX = this.pipeList[this.pipeList.length-1].x + 184;
            const gameObjectElement = this.facade.generateGameObject(this.pipeImage.gameElementSpecification);
            const imagenSprite = gameObjectElement.gameObject as Phaser.Physics.Matter.Sprite;
            imagenSprite.setAlpha(0.9);
            imagenSprite.setTint(ColorsValue.WHITE_HEXADECIMAL_VALUE);
            imagenSprite.setData('ColorValue', ColorsValue.WHITE_HEXADECIMAL_VALUE);
            imagenSprite.setData('ColorNumber', 0);

            this.addPipeFuncionality(imagenSprite);
            
            imagenSprite.setSensor(true);
            this.pipeList.push(imagenSprite);
            this.countStep = 0;
        }

        if (this.pipeList.length > 0) {
            this.pipeList.forEach(
                (gameObjectImage) => {
                    gameObjectImage.x -= 1.01;
                    if (gameObjectImage.x < 0) {
                        const firsElement =  this.pipeList.shift();
                        firsElement.destroy();
                    }
                }
            );
            this.countStep++;
        }
    }

    private getElements() {

        this.totalScoreText = this.gameObjects.get(
            'total-score'
        ).gameObject;
        
        this.mainSceneBackground = this.gameObjects.get(
            'scene-background'
        ).gameObject;

        const sceneModalBackground = this.gameObjects.get(
            'scene-modal-backgroud'
        ).gameObject as Phaser.GameObjects.Image;
        sceneModalBackground.setTint(ColorsValue.BLACK_HEXADECIMAL_VALUE);
        sceneModalBackground.setAlpha(0.5);

        this.pipeImage = this.gameObjects.get(
            'pipe-background'
        );
        const firstPipe = this.pipeImage.gameObject as Phaser.GameObjects.Sprite;
        this.addPipeFuncionality(firstPipe );
        this.pipeList.push(firstPipe);
        firstPipe.setVisible(false);

        const ballImage = this.gameObjects.get(
            'ball-background'
        );
        
        ballImage.gameObject.setVisible(false);

        this.ballArc = this.add.circle(ballImage.gameObject.x, ballImage.gameObject.y, ballImage.gameObject.width/2, 0xE50000);
        this.ballArcTemp = this.add.circle(ballImage.gameObject.x, 200, ballImage.gameObject.width/2, 0xE50000);

        this.ballSprite = this.matter.add.gameObject(
            this.ballArc,
            {
                label: ballImage.gameElementSpecification.name,
                shape: {
                    type: 'circle'
                }
            }
        ) as Phaser.Physics.Matter.Sprite;
	    this.ballSprite.setFriction(0, 0, 0);
        this.ballSprite.setVisible(false);
        
        this.animateBall();
    }

    private addPipeFuncionality(pipeGameObject: Phaser.GameObjects.Sprite) {
        pipeGameObject.setInteractive().on(
            EventsTouchedGameObjectsStrings.POINTERDOWN, () => {
                const colorNumber = pipeGameObject.getData('ColorNumber');
                changeGameObjectImage(
                    pipeGameObject,
                    this.pipeAssets[colorNumber],
                    this.pipeImage.gameElementSpecification.scale.objectWidth,
                    this.pipeImage.gameElementSpecification.scale.objectHeight
                );

                pipeGameObject.setData('ColorValue', this.pipeAssets[colorNumber]);  
                
                if (colorNumber < 2) {
                    pipeGameObject.setData('ColorNumber', colorNumber + 1);
                } else {
                    pipeGameObject.setData('ColorNumber', 0);
                }

            }
        );
    }

    private addFunctionality() {
        this.addPipeFuncionality(this.pipeImage.gameObject as Phaser.GameObjects.Sprite);

        this.matter.world.on(
            'collisionstart',
            (event, bodyA, bodyB) => {

                if (
                    bodyB.label === 'ball-background' || 
                    bodyA.label === 'ball-background' 
                ) {
                    if (bodyB.gameObject.getData('ColorValue') === this.ballArc.getData('ColorValue')) {
                        const randomNumber = this.randomIntFromInterval(0, this.colorValues.length);
                        this.ballArc.setFillStyle(this.colorValues[randomNumber]);
                        this.ballArc.setData('ColorValue', this.pipeAssets[randomNumber]);
                        if (!this.isVisibleBall) {
                            this.ballArcTemp.setFillStyle(this.colorValues[randomNumber]);
                        }
                        this.animation.stop();
                        this.animateBall();
                        bodyB.gameObject.disableInteractive();
                        if (bodyA.gameObject.getData('ColorValue') !== undefined) {
                            this.totalScore += 1;
                            this.totalScoreText.setText('PUNTAJE: ' + this.totalScore);
                        }
                        
                    } else {
                        const gameData: SceneDataInterface = {
                            returnSceneName: this.scene.key,
                            totalScore: this.totalScore
                        }
                        this.scene.stop(GameSceneIdsStrings.MAIN_SCENE_ID);
                        this.scene.start(GameSceneIdsStrings.END_SCENE_ID, gameData);
                    }
                }
            }
        )
    }

    private animateBall() {
        this.animation = this.tweens.add({
            targets: this.ballSprite,
            y: {
                getStart: () => 414,
                getEnd: () => 200
            },
            ease: 'Linear',
            duration: 1502,
            yoyo: true,
            repeat: 0
        });
    }

    private randomIntFromInterval(minimum: number, maximum: number): number {
        return Math.floor(Math.random() * (maximum - minimum) + minimum);
    }

    private initialCounter() {
        this.anims.create({
            key: 'initial-counter',
            frames: [
                { key: 'one-background', frame: 1},
                { key: 'one-background', frame: 1},
                { key: 'one-background', frame: 1},
                { key: 'two-background', frame: 1},
                { key: 'two-background', frame: 1},
                { key: 'two-background', frame: 1},
                { key: 'three-background', frame: 1},
                { key: 'three-background', frame: 1},
                { key: 'three-background', frame: 1},
                { key: 'three-background', frame: 1},
            ],
            frameRate: 6,
            repeat: 1
        });
        
        const counterBackground = this.add.sprite(683, 384, 'one-background').play('initial-counter');
        counterBackground.setDisplaySize(375, 375);
        
        setTimeout(() => {
            counterBackground.destroy();
        }, 1000);
    }
}